var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.998,
    height: 20,
    viewBox: "0 0 19.998 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_Outline",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M19.961,8.7l0,0L11.8.539a1.841,1.841,0,0,0-2.6,0L1.043,8.693,1.034,8.7A1.84,1.84,0,0,0,2.26,11.839l.057,0h.325v6A2.157,2.157,0,0,0,4.8,20H7.988a.586.586,0,0,0,.586-.586V14.707a.984.984,0,0,1,.983-.983H11.44a.984.984,0,0,1,.983.983v4.707a.586.586,0,0,0,.586.586H16.2a2.157,2.157,0,0,0,2.155-2.155v-6h.3a1.842,1.842,0,0,0,1.3-3.142Zm-.83,1.774a.665.665,0,0,1-.473.2H17.77a.586.586,0,0,0-.586.586v6.59a.984.984,0,0,1-.983.983H13.6V14.707a2.157,2.157,0,0,0-2.155-2.155H9.558A2.158,2.158,0,0,0,7.4,14.707v4.121H4.8a.984.984,0,0,1-.983-.983v-6.59a.586.586,0,0,0-.586-.586h-.9a.669.669,0,0,1-.461-1.142h0l8.158-8.158a.669.669,0,0,1,.946,0l8.156,8.156,0,0A.671.671,0,0,1,19.131,10.473Zm0,0",
    transform: "translate(0)",
    fill: "#7b818e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8a18003604db67d071225298d6686480.svg";
export { ForwardRef as ReactComponent };